import styled from 'styled-components'

// Utils
import { breakpoint } from '@sketch/global-styles'

// Components
import { IndexLayoutOldTitle } from '@sketch/modules-common'
import { LinkButton } from '@sketch/components'

export const FormContainer = styled.div`
  max-width: 400px;
  margin: 0 auto;
  width: 100%;
`

export const Paragraph = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.E};
`

export const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 32px;
`

export const BreadcrumbsWrapper = styled.div`
  display: none;

  ${breakpoint('sm')`
    display: block;

    text-align: center;
    margin-top: 16px;

    + ${IndexLayoutOldTitle} {
      margin-top: 32px;
    }
  `}
`

export const StyledLinkButton = styled(LinkButton)`
  width: 100%;
  margin-top: 32px;
`

export const Line = styled.div`
  width: 100%;
  margin-top: 32px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.A};
`
